
<template>
  <div class="raw-link-info">
    <!-- 网盘释放 -->
    <div class="rd-header">
<!--      <span class="rd-title">网盘释放</span>-->
      <el-tag type="success"  effect="dark" style="width: 70px;line-height: 25px;height: 25px">网盘释放</el-tag>
      <span class="rd-count" v-if="selectDetail?.approvalInfos?.length>1" @click="dialogVisible=true">共 {{ selectDetail?.approvalInfos?.length }} 条记录<i v-html="viewDetailIcon()"></i></span>
    </div>
    <div class="rd-body">
      <div class="rd-row">
        <span class="rd-lbl">释放时间：</span>
        <span class="rd-val">{{ Object.keys(rawLinkInfo)?.length>0?(selectDetail.createTime || 'NA'):'NA' }}</span>
      </div>
      <div class="rd-row" v-if="rawLinkInfo?.expirationTime">
        <span class="rd-lbl">失效时间：</span>
        <span class="rd-val">{{ rawLinkInfo?.expirationTime || '' }}</span>
      </div>
      <div class="rd-row">
        <span class="rd-lbl">状态：</span>
        <span class="rd-val rd-warn" v-if="Object.keys(rawLinkInfo)?.length===0||rawLinkInfo?.expired">已失效<span v-if="!rawLinkInfo?.expirationTime">且已清空</span></span>
        <span class="rd-val rd-ok" v-else>生效中</span>
      </div>
    </div>
    <!-- 释放记录弹框 -->
    <approval-record-dialog
        :show-dialog.sync="dialogVisible"
        title="网盘释放记录"
        :columns="columns"
        :project-id="selectDetail.id||''"
        :table-data="selectDetail.approvalInfos || []">
    </approval-record-dialog>
  </div>
</template>

<script>
import {viewDetailIcon, yunIcon} from "@/utils/iconUtils";
import ApprovalRecordDialog from "@/components/RawDataReleaseInfo/ApprovalRecordDialog.vue";

export default {
  name: "RawLinkInfo",
  components: {ApprovalRecordDialog},
  data() {
    return {
      yunIcon: yunIcon,
      dialogVisible: false,
      columns: [
        {title: '释放时间', dataIndex: 'operateTime', key: 'operateTime'},
        {title: '样本数', dataIndex: 'sampleNum', key: 'sampleNum', width: 100},
        {title: '样本信息', dataIndex: 'sampleInfo', key: 'sampleInfo', scopedSlots: {customRender: 'sampleInfo'},width: 100},
      ],
    }
  },
  props: {
    selectDetail: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    rawLinkInfo() {
      return this.selectDetail?.rawInfo?.LINK || {}
    }
  },
  methods: {
    viewDetailIcon() {
      return viewDetailIcon
    },
    lookSampleInfo() {
      this.$emit('lookSampleInfo', this.selectDetail)
    },
  },

}
</script>

<style scoped>
.raw-link-info {
  font-size: 13px;
  color: #303133;
}
/* 头部：彩色标题 + 底部浅色分隔线 */
.rd-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3px;
  padding-bottom: 3px;
}
.rd-title {
  position: relative;
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: .5px;
  color: #3a9c3a;
}
.rd-count {
  font-size: 12px;
  color: #3a9c3a;
  cursor: pointer;
  transition: opacity .15s;
}
.rd-count:hover {
  opacity: .7;
  text-decoration: underline;
}
/* 左边线极简：标签两端对齐等宽 + 值加粗，宽松行距 */
.rd-body {
  line-height: 1.3;
}
.rd-row {
  display: flex;
  align-items: baseline;
  padding: 1px 0;
}
.rd-lbl {
  width: 5em;
  text-align: justify;
  text-align-last: justify;
  color: #3a9c3a;
  white-space: nowrap;
  flex-shrink: 0;
}
.rd-val {
  color: #3a9c3a;
  font-weight: 500;
  word-break: break-all;
}
.rd-ok {
  color: #3a9c3a;
}
.rd-warn {
  color: #f14444;
}
</style>
